import type { TUser, TUtils } from "@monta/utils";
import { jwtDecode } from "jwt-decode";
import type { IUser } from "../hooks/useUser";
import { checkTabId } from "./checkTabId";
import { ALREADY_LOGGEDIN } from "./endpoints";
import { sendToExam } from "./sendToExam";

export const deleteUserExcessData = (user: any) => {
  delete user.moduleAccessInfo;
  delete user.mainMenu;
  delete user.sideMenu;
  delete user.features;
  delete user.isSurveyForced;
  delete user.surveyID;
  delete user.surveyDescription;
  delete user.surveyTitle;
  return user;
};

export type TJWT = {
  user: Partial<TUser>;
  iat: number;
  exp: number;
  jti: string;
};

export const TOKEN_UPDATED_EVENT = "TOKEN_UPDATED_EVENT";
export const dispatchTokenUpdate = () => {
  window.dispatchEvent(new Event(TOKEN_UPDATED_EVENT));
};

export const isTokenExpired = (token: string) => {
  if (!token) return;
  const { exp } = jwtDecode<TJWT>(token);
  const now = new Date().getTime() / 1000;
  return now > exp;
};

export const LOCAL_STORAGE_USER_UPDATE_EVENT =
  "LOCAL_STORAGE_USER_UPDATE_EVENT";
export const callAlreadyLogin = (api: TUtils["api"]) =>
  api
    .$post(ALREADY_LOGGEDIN(), { fp: "" })
    .then(deleteUserExcessData)
    .then((res) => {
      localStorage.setItem("user", JSON.stringify(res));
      window.dispatchEvent(new Event(LOCAL_STORAGE_USER_UPDATE_EVENT));
      return res as IUser;
    });

export const checkAuth = async (utils: TUtils) => {
  const { api, auth } = utils;
  return callAlreadyLogin(api)
    .then((res) => {
      checkTabId();
      sendToExam(res);
      return res;
    })
    .catch(() => {
      auth?.logout();
      localStorage.removeItem("user");
      return Promise.resolve(false);
    });
};
